<template>
    <div>
        <v-row v-for="(item, yearIndex) in items" :key="yearIndex" :justify="yearIndex % 2 == 0 ? 'end' : 'start'" no-gutters class="history-list">
            <v-col cols="12">
                <v-card flat rounded="pill" color="#f7f7f7" class="year">
                    <v-responsive aspect-ratio="1">
                        {{ item.year }}
                    </v-responsive>
                </v-card>
            </v-col>
            <v-col cols="12" md="6" class="items" :class="yearIndex % 2 == 0 ? 'items--odd' : 'items--even'">
                <v-card tile flat>
                    <v-row v-for="(item, index) in item.items" :key="index" no-gutters>
                        <v-col cols="auto">
                            <v-sheet min-width="24" class="month" :class="{ 'mt-12': index !== 0 }">{{ item.month }}월</v-sheet>
                        </v-col>
                        <v-col>
                            <div :class="{ 'mt-12': index !== 0 }" class="gutter">
                                <v-row v-for="(item, index) in item.items" :key="index" no-gutters :class="{ 'pt-12': index !== 0 }">
                                    <v-col>
                                        <span v-if="item.date">{{ item.date }}일&nbsp;</span><span v-html="item.text" />
                                    </v-col>
                                    <template v-if="item.logo">
                                        <v-col cols="12" lg="auto" :order-lg="yearIndex % 2 == 0 ? undefined : 'first'">
                                            <v-img v-for="(image, index) in item.logo" :key="index" :src="image" max-width="112" alt="" class="d-inline-block d-lg-block" />
                                        </v-col>
                                    </template>
                                    <v-col v-if="item.plus" cols="12">
                                        <p class="primary--text mt-4 text-pre-wrap">{{ item.plus }}</p>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    year: 2026,
                    items: [
                        {
                            month: 5,
                            items: [
                                {
                                    text: "목동사회종합복지관 MOU 체결",
                                },
                            ],
                        },
                        {
                            month: 4,
                            items: [
                                {
                                    text: "마곡어르신 복지관 LED 몰입형 VR 시스템 기증 및 MOU 체결",
                                },
                            ],
                        },
                        {
                            month: 3,
                            items: [
                                {
                                    text: "유아스포츠 VR체육 현장 설명회 및 체험 실시",
                                },
                            ],
                        },
                        {
                            month: 2,
                            items: [
                                {
                                    text: "강서구 지역아동센터 사랑나눔 후원금 전달식",
                                },
                            ],
                        },
                        {
                            month: 1,
                            items: [
                                {
                                    text: "구립 강서청소년회관 몰입형 VR 공익 프로그램 협약식",
                                },
                            ],
                        },
                    ],
                },
                {
                    year: 2025,
                    items: [
                        {
                            month: 12,
                            items: [
                                {
                                    text: "강서구청 구립 어르신 복지관 VR 기탁사업 실시",
                                },
                                {
                                    text: "전주 신일중학교 체육용품 지원",
                                },
                            ],
                        },
                        {
                            month: 10,
                            items: [
                                {
                                    text: "유더스타스FC 강서구청장배 대회 참여 공동 3위",
                                },
                            ],
                        },
                        {
                            month: 4,
                            items: [
                                {
                                    date: 23,
                                    text: "서울 지역아동센터 중랑구 몰입형 VR 프로그램 지원",
                                    logo: [
                                        "/images/sub/about/business/history-logo-1.png",
                                        "/images/sub/about/business/history-logo-2.png",
                                        //
                                    ],
                                },
                                {
                                    date: 17,
                                    text: "서울 지역아동센터 강서구 몰입형 VR 프로그램 지원",
                                    logo: [
                                        "/images/sub/about/business/history-logo-3.png",
                                        "/images/sub/about/business/history-logo-4.png",
                                        //
                                    ],
                                },
                            ],
                        },
                        {
                            month: 3,
                            items: [
                                {
                                    date: 24,
                                    text: "<strong class='primary--text'>몰입형 VR 시스템 “ProFrom VR Training” 런칭</strong>",
                                },
                                {
                                    date: 5,
                                    text: "서울 지역아동센터 협의회 몰입형 VR 프로그램 개시",
                                },
                            ],
                        },
                        {
                            month: 1,
                            items: [
                                {
                                    date: 15,
                                    text: "서울 지역아동센터 협의회 몰입형 VR 설명회 개최",
                                },
                            ],
                        },
                    ],
                },
                {
                    year: 2024,
                    items: [
                        {
                            month: 8,
                            items: [
                                {
                                    date: 12,
                                    text: "<strong class='primary--text'>교육부 강서양천교육청 “진로체험 인증기관” 3년 연장</strong>",
                                },
                            ],
                        },
                        {
                            month: 7,
                            items: [
                                {
                                    date: 23,
                                    text: "인천광역시 교육청 직업체험기관 75개 선정 수업 진행",
                                },
                            ],
                        },
                        {
                            month: 6,
                            items: [
                                {
                                    date: 12,
                                    text: "등촌 종합사회복지관 청소년댄스 체육수업 개시",
                                },
                            ],
                        },
                        {
                            month: 4,
                            items: [
                                {
                                    date: 23,
                                    text: "서울특별시 강서구 지역아동센터 협의회 축구단 2기 시작",
                                },
                            ],
                        },
                        {
                            month: 3,
                            items: [
                                {
                                    date: 19,
                                    text: "서울특별시 스포츠 과제 “핫둘핫둘 유아스포츠단” 운영 개시",
                                },
                            ],
                        },
                    ],
                },
                {
                    year: 2023,
                    items: [
                        {
                            month: 12,
                            items: [
                                {
                                    text: "<strong class='primary--text'>교육부장관 “진로체험 유관기관” 부분 대상 표창</strong>",
                                },
                            ],
                        },
                        {
                            month: 5,
                            items: [
                                {
                                    date: 22,
                                    text: "인천광역시 교육청 직업체험기관 75개 선정 수업 진행",
                                    plus: "경기도 하남시 리틀야구클럽 비영리 민간단체 등록",
                                },
                                {
                                    date: 19,
                                    text: "재단법인 유더스타스포츠 세번째 체육시설 개설",
                                },
                            ],
                        },
                        {
                            month: 4,
                            items: [
                                {
                                    date: 14,
                                    text: "재단법인 유더스타스포츠 인천(청라)지사 설립",
                                },
                            ],
                        },
                        {
                            month: 2,
                            items: [
                                {
                                    date: 21,
                                    text: "재단법인 유더스타스포츠 대한체육회 등록스포츠클럽 승인 → 대한체육회 등록기관",
                                },
                            ],
                        },
                    ],
                },
                {
                    year: 2022,
                    items: [
                        {
                            month: 9,
                            items: [
                                {
                                    date: 29,
                                    text: "재단법인 유더스타스포츠 두번째 체육시설 개설",
                                },
                            ],
                        },
                        {
                            month: 3,
                            items: [
                                {
                                    date: 15,
                                    text: "재단법인 유더스타스포츠 체육시설업 자진 신고",
                                },
                            ],
                        },
                    ],
                },
                {
                    year: 2021,
                    items: [
                        {
                            month: 7,
                            items: [
                                {
                                    date: 9,
                                    text: "재단법인 유더스타스포츠 공식 교육기부 진로체험(기관) 인증",
                                    plus: "교육부 인증 유관기관",
                                },
                            ],
                        },
                    ],
                },
                {
                    year: 2020,
                    items: [
                        {
                            month: 9,
                            items: [
                                {
                                    date: 28,
                                    text: "재단법인 유더스타스포츠 지정기부금 단체 승인",
                                    plus: "기획재정부 소관 서울특별시 소속",
                                },
                            ],
                        },
                        {
                            month: 6,
                            items: [
                                {
                                    date: 2,
                                    text: "유더스타스포츠재단 법인 승인 및 법인 사업자 등록",
                                },
                            ],
                        },
                        {
                            month: 5,
                            items: [
                                {
                                    date: 21,
                                    text: "유더스타스포츠재단 승인",
                                },
                            ],
                        },
                        {
                            month: 3,
                            items: [
                                {
                                    date: 14,
                                    text: "(가칭)유더스타스포츠재단 전용 체육시설 개설",
                                    plus: "민법 제32조 및 문화체육관광부 및 문화재청 소관 비영리법인의\n설립 및 감독에 관한 규칙",
                                },
                            ],
                        },
                    ],
                },
                {
                    year: 2018,
                    items: [
                        {
                            month: 11,
                            items: [
                                {
                                    text: "(가칭)유더스타스포츠재단 출범 사업개시",
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.history-list {
    line-height: 1.5;
    &:last-child {
        .items {
            > .v-card {
                &::after {
                    display: none;
                }
            }
        }
    }
}
.year {
    max-width: 130px;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    transform: translateX(-50%);
    padding-left: 40px;
    ::v-deep(.v-responsive__content) {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.items {
    > .v-card {
        color: #666;
        padding-top: 60px;
        padding-bottom: 60px;
        padding-left: 12px;
        position: relative;
        .month {
            color: #111;
            font-weight: 500;
            position: relative;
            margin-right: 12px;
            &::before {
                content: "";
                position: absolute;
                top: 50%;
                left: -14px;
                transform: translateY(-50%);
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: var(--v-primary-base);
                z-index: 1;
            }
        }
        &::before,
        &::after {
            content: "";
            position: absolute;
            left: 0;
            width: 100%;
            height: 50%;
            border-left: 1px solid #d9d9d9;
        }
        &::before {
            top: 0;
        }
        &::after {
            bottom: 0;
        }
    }
}
@media (min-width: 768px) {
    .year {
        margin: 0 auto;
        transform: initial;
        padding-left: 0;
        font-size: 28px;
    }
    .items {
        > .v-card {
            .month {
                &::before {
                    width: 7px;
                    height: 7px;
                    left: -43px;
                }
            }
        }
        &--odd {
            > .v-card {
                padding-left: 40px;
            }
        }
        &--even {
            > .v-card {
                padding-left: 0;
                padding-right: 40px;
                border-left: 0;
                text-align: end;
                .month {
                    margin-right: 0;
                    margin-left: 12px;
                    &::before {
                        left: initial;
                        right: -43px;
                    }
                }
                &::before,
                &::after {
                    border-left: none;
                    border-right: 1px solid #d9d9d9;
                }
                > .row {
                    > .col {
                        &:nth-child(1) {
                            order: 2;
                        }
                        &:nth-child(2) {
                            > .gutter {
                                > .row {
                                    justify-content: flex-end;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>